/*
 * @Author: 吴文洁
 * @Date: 2019-11-21 21:59:58
 * @LastEditors: 吴文洁
 * @LastEditTime: 2020-01-29 11:27:50
 * @Description: 
 */
/**
 * 优惠券使用范围
 */
import XMEnum from './XMEnum';

 const CouponUseRangeEnum = new XMEnum([
     {name: 'NONE', code: 'NONE', describe: '无限制'},
     {name: 'OFFLINE', code: 'OFFLINE', describe: '线下'},
     {name: 'ON_LINE', code: 'ON_LINE', describe: '线上'},
 ]);

 export default CouponUseRangeEnum;


// WEBPACK FOOTER //
// ./src/enum/CouponUseRangeEnum.js